package br.com.htms.inspeccaocampo.ui.screens

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.horizontalScroll
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.AccountBox
import androidx.compose.material.icons.filled.ArrowBack
import androidx.compose.material.icons.filled.ArrowForward
import androidx.compose.material.icons.filled.DateRange
import androidx.compose.material.icons.filled.Edit
import androidx.compose.material.icons.filled.Info
import androidx.compose.material.icons.filled.List
import androidx.compose.material.icons.filled.LocationOn
import androidx.compose.material.icons.filled.Person
import androidx.compose.material.icons.filled.Refresh
import androidx.compose.material.icons.filled.Star
import androidx.compose.material.icons.filled.Warning
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.Checkbox
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateListOf
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import br.com.htms.inspeccaocampo.data.ativos.AtivosFormat
import br.com.htms.inspeccaocampo.data.efetivo.CustoMes
import br.com.htms.inspeccaocampo.data.efetivo.Datas
import br.com.htms.inspeccaocampo.data.efetivo.EfetivoApi
import br.com.htms.inspeccaocampo.data.efetivo.EfetivoDados
import br.com.htms.inspeccaocampo.data.efetivo.EfetivoLog
import br.com.htms.inspeccaocampo.data.efetivo.FolgaStatus
import br.com.htms.inspeccaocampo.data.efetivo.FuncEfetivo
import br.com.htms.inspeccaocampo.data.efetivo.ImportacaoFolha
import br.com.htms.inspeccaocampo.data.efetivo.RegrasEfetivo
import br.com.htms.inspeccaocampo.data.efetivo.TiposDia
import br.com.htms.inspeccaocampo.data.efetivo.Transferencia
import br.com.htms.inspeccaocampo.form.AppController
import br.com.htms.inspeccaocampo.platform.currentTimeMillis
import br.com.htms.inspeccaocampo.platform.formatDateTimeBr
import br.com.htms.inspeccaocampo.ui.kit.AvisoFaixa
import br.com.htms.inspeccaocampo.ui.kit.Campo
import br.com.htms.inspeccaocampo.ui.kit.CampoBusca
import br.com.htms.inspeccaocampo.ui.kit.BotaoCores
import br.com.htms.inspeccaocampo.ui.kit.CartaoSecao
import br.com.htms.inspeccaocampo.ui.kit.CoresDash
import br.com.htms.inspeccaocampo.ui.kit.Celula
import br.com.htms.inspeccaocampo.ui.kit.CelulaCabecalho
import br.com.htms.inspeccaocampo.ui.kit.CelulaCabecalhoOrdenavel
import br.com.htms.inspeccaocampo.ui.kit.rememberOrdem
import br.com.htms.inspeccaocampo.ui.kit.ChipCor
import br.com.htms.inspeccaocampo.ui.kit.Kpi
import br.com.htms.inspeccaocampo.ui.kit.LinhaKpis
import br.com.htms.inspeccaocampo.ui.kit.LinhaTabela
import br.com.htms.inspeccaocampo.ui.kit.OpcaoResposta
import br.com.htms.inspeccaocampo.ui.kit.PainelFixo
import br.com.htms.inspeccaocampo.ui.kit.Par
import br.com.htms.inspeccaocampo.ui.kit.PortalButton
import br.com.htms.inspeccaocampo.ui.kit.PortalMenuItem
import br.com.htms.inspeccaocampo.ui.kit.PortalModal
import br.com.htms.inspeccaocampo.ui.kit.PortalModulo
import br.com.htms.inspeccaocampo.ui.kit.PortalOutlinedButton
import br.com.htms.inspeccaocampo.ui.kit.Seletor
import br.com.htms.inspeccaocampo.ui.kit.TabelaPortal
import br.com.htms.inspeccaocampo.ui.kit.TituloSecao
import br.com.htms.inspeccaocampo.ui.kit.corVinculo
import br.com.htms.inspeccaocampo.ui.dashboards.DashboardEfetivo
import br.com.htms.inspeccaocampo.ui.theme.PortalCores
import kotlinx.coroutines.launch

private enum class AbaEfetivo(val rotulo: String) {
    EFETIVO("Efetivo"),
    DASHBOARD("Dashboard"),
    TRANSF("Transferências"),
    LANC("Lançamentos"),
    FOLGAS("Folgas"),
    CUSTO("Custo"),
    CAD("Cadastros"),
    ALT("Alterações")
}

private val CorFolga = Color(0xFF2E7D32)
private val CorFerias = Color(0xFF1565C0)
private val CorFeriado = Color(0xFFB26A00)

private fun corTipo(t: String): Color = when (t) {
    "folga" -> CorFolga
    "ferias", "afastamento" -> CorFerias
    "falta" -> PortalCores.Vermelho
    "feriado" -> CorFeriado
    "descanso_semanal" -> PortalCores.CinzaTexto
    else -> PortalCores.Navy
}

private fun chipFolga(status: String): Pair<String, Color> = when (status) {
    FolgaStatus.EM_DIA -> "Em dia" to PortalCores.Verde
    FolgaStatus.PROXIMA -> "Folga próxima" to PortalCores.Laranja
    FolgaStatus.ADIADA -> "Adiada p/ fim de ano" to CorFerias
    FolgaStatus.ATRASADA -> "Atrasada" to PortalCores.Vermelho
    else -> "Sem data de admissão" to PortalCores.CinzaTexto
}

private fun chipTransf(t: Transferencia): Pair<String, Color> = when (t.status) {
    "pendente" -> "Pendente" to PortalCores.Laranja
    "parcial" -> "Parcialmente aprovada" to PortalCores.Laranja
    "aplicada" -> "Aprovada e aplicada" to PortalCores.Verde
    "recusada" -> "Recusada" to PortalCores.Vermelho
    else -> "Cancelada" to PortalCores.CinzaTexto
}

private fun centavos(c: Long): String = AtivosFormat.moeda(c / 100.0)

@Composable
fun SharedEfetivoScreen(controller: AppController) {
    val scope = rememberCoroutineScope()
    var dados by remember { mutableStateOf<EfetivoDados?>(null) }
    var erro by remember { mutableStateOf<String?>(null) }
    var carregando by remember { mutableStateOf(false) }
    var aviso by remember { mutableStateOf<Pair<String, Color>?>(null) }
    var aba by remember { mutableStateOf(AbaEfetivo.EFETIVO) }
    var ref by remember { mutableStateOf("") }

    fun recarregar() {
        carregando = true
        scope.launch {
            EfetivoApi.dados()
                .onSuccess {
                    dados = it
                    erro = null
                    if (ref.isBlank()) ref = it.hoje
                }
                .onFailure { erro = it.message ?: "Falha ao carregar o Controle de Efetivo." }
            carregando = false
        }
    }

    /** Executa a ação no servidor, mostra a mensagem e recarrega os dados. */
    fun executar(okMsg: String, acao: suspend () -> Result<*>) {
        scope.launch {
            acao()
                .onSuccess {
                    aviso = okMsg to PortalCores.Verde
                    recarregar()
                }
                .onFailure { aviso = (it.message ?: "Falha ao salvar.") to PortalCores.Vermelho }
        }
    }

    LaunchedEffect(Unit) { recarregar() }

    val d = dados
    val pendentesParaMim = d?.transferencias.orEmpty().count { t ->
        t.aberta && listOf("origem", "destino").any { t.lado(it).dec == "pendente" && d!!.podeDecidir(t.lado(it).obra) }
    }
    val abas = AbaEfetivo.entries.filter { it != AbaEfetivo.CUSTO || (d?.custoAtivo == true && d.master) }
    val icone = mapOf(
        AbaEfetivo.EFETIVO to Icons.Filled.Person,
        AbaEfetivo.DASHBOARD to Icons.Filled.Star,
        AbaEfetivo.TRANSF to Icons.Filled.ArrowForward,
        AbaEfetivo.LANC to Icons.Filled.Edit,
        AbaEfetivo.FOLGAS to Icons.Filled.DateRange,
        AbaEfetivo.CUSTO to Icons.Filled.AccountBox,
        AbaEfetivo.CAD to Icons.Filled.List,
        AbaEfetivo.ALT to Icons.Filled.Info
    )
    val itens = abas.map {
        PortalMenuItem(it.name, it.rotulo, icone.getValue(it), destaque = it == AbaEfetivo.TRANSF && pendentesParaMim > 0)
    }

    PortalModulo(
        titulo = "Controle de Efetivo",
        itens = itens,
        selecionado = aba.name,
        onSelect = { aba = AbaEfetivo.valueOf(it) },
        extraCabecalho = {
            if (ref.isNotBlank()) {
                IconButton(onClick = { ref = Datas.add(ref, -1) }) {
                    Icon(Icons.Filled.ArrowBack, contentDescription = "Dia anterior", tint = PortalCores.Navy)
                }
                Column(horizontalAlignment = Alignment.CenterHorizontally) {
                    Text("Referência", style = MaterialTheme.typography.labelSmall, color = PortalCores.CinzaTexto)
                    Text(
                        "${Datas.br(ref)} (${Datas.DIAS_SEMANA[Datas.dow(ref)]})",
                        fontWeight = FontWeight.Bold,
                        color = PortalCores.Navy
                    )
                }
                IconButton(onClick = { ref = Datas.add(ref, 1) }) {
                    Icon(Icons.Filled.ArrowForward, contentDescription = "Dia seguinte", tint = PortalCores.Navy)
                }
                if (d != null && ref != d.hoje) TextButton(onClick = { ref = d.hoje }) { Text("Hoje") }
            }
            BotaoPlanilha(controller, br.com.htms.inspeccaocampo.export.PlanilhaModulo.EFETIVO)
            IconButton(onClick = { recarregar() }, enabled = !carregando) {
                Icon(Icons.Filled.Refresh, contentDescription = "Atualizar", tint = PortalCores.Navy)
            }
        }
    ) { largo ->
        aviso?.let { (msg, cor) -> AvisoFaixa(msg, cor) { aviso = null } }
        if (d == null) {
            if (erro != null) {
                CartaoSecao("Controle de Efetivo") {
                    Text(erro.orEmpty(), color = PortalCores.Vermelho)
                    PortalOutlinedButton(onClick = { recarregar() }) { Text("Tentar de novo") }
                }
            } else {
                Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(12.dp)) {
                    CircularProgressIndicator(modifier = Modifier.size(22.dp), strokeWidth = 2.dp)
                    Text("Carregando o efetivo...", color = PortalCores.CinzaTexto)
                }
            }
            return@PortalModulo
        }
        when (aba) {
            AbaEfetivo.EFETIVO -> AbaPainel(d, ref, largo, ::executar) { aba = it }
            AbaEfetivo.DASHBOARD -> DashboardEfetivo(d, carregando) { recarregar() }
            AbaEfetivo.TRANSF -> AbaTransferencias(d, ref, largo, ::executar)
            AbaEfetivo.LANC -> AbaLancamentos(d, ref, largo, ::executar)
            AbaEfetivo.FOLGAS -> AbaFolgas(d, ref, largo)
            AbaEfetivo.CUSTO -> AbaCusto(d, largo, ref) { msg, cor -> aviso = msg to cor }
            AbaEfetivo.CAD -> AbaCadastros(d, ref, largo, ::executar)
            AbaEfetivo.ALT -> AbaAlteracoes(d)
        }
    }
}

// ---------------------------------------------------------------- Efetivo (painel)

private class ResumoObra {
    var trabalho = 0
    var fora = 0
    val pessoas = mutableListOf<Pair<FuncEfetivo, String>>()
    val real = mutableMapOf<String, Int>()
    val total: Int get() = trabalho + fora
}

@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun AbaPainel(
    d: EfetivoDados,
    ref: String,
    largo: Boolean,
    executar: (String, suspend () -> Result<*>) -> Unit,
    irPara: (AbaEfetivo) -> Unit
) {
    val por = linkedMapOf<String, ResumoObra>()
    var semObra = 0
    var trabalhando = 0
    var fora = 0
    for (f in d.funcionarios) {
        if (!f.noQuadro(ref)) continue
        val o = RegrasEfetivo.obraEm(f.aloc, ref)
        if (o == null) {
            semObra++
            continue
        }
        val t = RegrasEfetivo.tipoDia(f, ref)
        val r = por.getOrPut(o) { ResumoObra() }
        r.pessoas += f to t
        if (t == TiposDia.TRABALHO) {
            r.trabalho++
            trabalhando++
            r.real[f.funcaoOuSem] = (r.real[f.funcaoOuSem] ?: 0) + 1
        } else {
            r.fora++
            fora++
        }
    }
    val previstoPor = d.previsto.groupBy { it.cc }.mapValues { (_, l) -> l.associate { it.funcao to it.qtd } }
    val obras = (por.keys + previstoPor.keys).distinct().sortedBy { d.codigo(it) }
    val pendentes = d.transferencias.count { it.aberta }
    BotaoCores(
        listOf(
            "Trabalhando" to 0xFF1B7F3B,
            "Folga / ausentes" to 0xFF1565C0,
            "Sem obra" to 0xFFC62828,
            "Transferências pendentes" to 0xFFE07B00
        )
    )

    LinhaKpis(largo) { m ->
        Kpi("Trabalhando", trabalhando.toString(), Icons.Filled.Person, m, cor = CoresDash.de("Trabalhando", 0xFF1B7F3B), legenda = "Na data de referência")
        Kpi("Folga / ausentes", fora.toString(), Icons.Filled.DateRange, m, cor = CoresDash.de("Folga / ausentes", 0xFF1565C0), legenda = "Folga, férias, falta...", onClick = { irPara(AbaEfetivo.FOLGAS) })
        Kpi("Sem obra", semObra.toString(), Icons.Filled.Warning, m, cor = CoresDash.de("Sem obra", 0xFFC62828), alerta = semObra > 0, legenda = "Alocar em Cadastros", onClick = { irPara(AbaEfetivo.CAD) })
        Kpi("Transferências pendentes", pendentes.toString(), Icons.Filled.ArrowForward, m, cor = CoresDash.de("Transferências pendentes", 0xFFE07B00), alerta = pendentes > 0, onClick = { irPara(AbaEfetivo.TRANSF) })
    }

    CartaoSecao(
        "Efetivo em ${Datas.br(ref)}",
        subtitulo = "Previsto por função × realizado (quem está trabalhando na data). Cada funcionário está em uma única obra por dia."
    ) {
        if (obras.isEmpty()) {
            Text("Ninguém alocado ainda. Use Cadastros → Funcionários sem obra para fazer a alocação inicial.", color = PortalCores.CinzaTexto)
        }
        if (largo && obras.isNotEmpty()) {
            val ordem = rememberOrdem("OBRA")
            val linhasObra = ordem.aplicar(obras) { o ->
                val r = por[o] ?: ResumoObra()
                when (ordem.col) {
                    "QTD" -> r.total.toString().padStart(6, '0')
                    else -> d.rotulo(o)
                }
            }
            TabelaPortal(cabecalho = {
                CelulaCabecalhoOrdenavel("Obra", 2.2f, ordem.marca("OBRA")) { ordem.clique("OBRA") }
                CelulaCabecalho("Previsto por função", 2.4f)
                CelulaCabecalho("Realizado por função", 2.4f)
                CelulaCabecalhoOrdenavel("Alocados", 0.8f, ordem.marca("QTD")) { ordem.clique("QTD") }
            }) {
                linhasObra.forEach { o ->
                    val r = por[o] ?: ResumoObra()
                    val pv = previstoPor[o].orEmpty()
                    val falta = pv.entries.sumOf { (fn, q) -> (q - (r.real[fn] ?: 0)).coerceAtLeast(0) }
                    LinhaTabela {
                        Celula(d.rotulo(o), 2.2f, negrito = true)
                        Column(Modifier.weight(2.4f).padding(end = 10.dp)) { ResumoFuncoes(pv) }
                        Column(Modifier.weight(2.4f).padding(end = 10.dp)) {
                            ResumoFuncoes(r.real)
                            if (falta > 0) Text("faltam $falta em relação ao previsto", color = PortalCores.Vermelho, style = MaterialTheme.typography.bodySmall)
                        }
                        Celula(r.total.toString(), 0.8f, negrito = true)
                    }
                }
            }
        } else {
            obras.forEach { o ->
                val r = por[o] ?: ResumoObra()
                Column(
                    Modifier.fillMaxWidth().border(1.dp, PortalCores.Borda, RoundedCornerShape(10.dp)).padding(12.dp),
                    verticalArrangement = Arrangement.spacedBy(4.dp)
                ) {
                    Text(d.rotulo(o), fontWeight = FontWeight.Bold, color = PortalCores.Navy)
                    Text("${r.total} alocados · ${r.trabalho} trabalhando", color = PortalCores.CinzaTexto, style = MaterialTheme.typography.bodySmall)
                    Text("Previsto", style = MaterialTheme.typography.labelMedium)
                    ResumoFuncoes(previstoPor[o].orEmpty())
                    Text("Realizado", style = MaterialTheme.typography.labelMedium)
                    ResumoFuncoes(r.real)
                }
            }
        }
        if (semObra > 0) {
            Text("$semObra funcionário(s) ativo(s) sem obra nesta data.", color = PortalCores.Laranja, fontWeight = FontWeight.SemiBold)
        }
    }

    val editaveis = d.centros.filter { it.ativo && d.podeDecidir(it.id) }
    if (editaveis.isNotEmpty()) {
        var cc by remember { mutableStateOf(editaveis.first().id) }
        var funcao by remember { mutableStateOf("") }
        var qtd by remember { mutableStateOf("") }
        CartaoSecao(
            "Ajustar efetivo previsto",
            subtitulo = "Quantas pessoas de cada função (cargos já cadastrados) a obra deve ter. Para tirar uma função, informe 0."
        ) {
            Par(
                largo,
                { m -> Seletor("Obra", editaveis.map { it.id to it.rotulo }, cc, { cc = it }, m) },
                { m -> Seletor("Função", d.funcoes.map { it to it }, funcao, { funcao = it }, m) }
            )
            val atual = previstoPor[cc]?.get(funcao.uppercase())
            Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(12.dp)) {
                Campo("Previsto", qtd, numero = true, modifier = Modifier.width(140.dp)) { qtd = it.filter(Char::isDigit).take(3) }
                if (funcao.isNotBlank()) Text("Hoje: ${atual ?: 0}", color = PortalCores.CinzaTexto)
                Spacer(Modifier.weight(1f))
                PortalButton(
                    onClick = {
                        val n = qtd.toIntOrNull() ?: return@PortalButton
                        executar("Previsto salvo.") { EfetivoApi.salvarPrevisto(cc, funcao, n) }
                        qtd = ""
                    },
                    enabled = d.podeEditar && funcao.isNotBlank() && qtd.isNotBlank()
                ) { Text("Salvar previsto") }
            }
        }
    }

    var aberta by remember { mutableStateOf<String?>(null) }
    CartaoSecao("Quem está em cada obra", subtitulo = "Toque na obra para ver os nomes.") {
        obras.filter { por[it] != null }.forEach { o ->
            val r = por.getValue(o)
            Row(
                Modifier.fillMaxWidth().clickable { aberta = if (aberta == o) null else o }.padding(vertical = 6.dp),
                verticalAlignment = Alignment.CenterVertically
            ) {
                Text(d.rotulo(o), Modifier.weight(1f), fontWeight = FontWeight.SemiBold, color = PortalCores.Navy)
                Text("${r.pessoas.size} alocados", color = PortalCores.CinzaTexto)
                Text(if (aberta == o) "  ▲" else "  ▼", color = PortalCores.CinzaTexto)
            }
            if (aberta == o) {
                r.pessoas.sortedBy { it.first.nome }.forEach { (f, t) ->
                    Row(Modifier.fillMaxWidth().padding(start = 12.dp, top = 2.dp, bottom = 2.dp), verticalAlignment = Alignment.CenterVertically) {
                        Text(f.nome, Modifier.weight(1f))
                        Text(f.funcao, color = PortalCores.CinzaTexto, style = MaterialTheme.typography.bodySmall, modifier = Modifier.weight(1f))
                        if (t != TiposDia.TRABALHO) ChipCor(TiposDia.rotulo(t), corTipo(t))
                    }
                }
            }
            HorizontalDivider(color = PortalCores.Borda)
        }
    }
}

@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun ResumoFuncoes(mapa: Map<String, Int>) {
    val itens = mapa.filterValues { it > 0 }.entries.sortedBy { it.key }.associate { it.key to it.value }
    if (itens.isEmpty()) {
        Text("—", color = PortalCores.CinzaClaro)
        return
    }
    FlowRow(horizontalArrangement = Arrangement.spacedBy(6.dp), verticalArrangement = Arrangement.spacedBy(4.dp)) {
        itens.forEach { (fn, n) ->
            Text(
                "$fn  $n",
                style = MaterialTheme.typography.bodySmall,
                modifier = Modifier.background(PortalCores.FundoPainel, RoundedCornerShape(6.dp)).padding(horizontal = 8.dp, vertical = 3.dp)
            )
        }
    }
}

// ---------------------------------------------------------------- Transferências

@Composable
private fun AbaTransferencias(d: EfetivoDados, ref: String, largo: Boolean, executar: (String, suspend () -> Result<*>) -> Unit) {
    var origem by remember { mutableStateOf("") }
    var fid by remember { mutableStateOf("") }
    var destino by remember { mutableStateOf("") }
    var ini by remember(ref) { mutableStateOf(Datas.br(ref)) }
    var fim by remember { mutableStateOf("") }
    var motivo by remember { mutableStateOf("") }
    var erroForm by remember { mutableStateOf<String?>(null) }
    val centrosAtivos = d.centros.filter { it.ativo }

    CartaoSecao(
        "Solicitar transferência",
        subtitulo = "A alocação só muda depois da aprovação dos engenheiros responsáveis das duas obras. A data de início pode ser retroativa."
    ) {
        val naOrigem = d.funcionarios.filter { it.noQuadro(ref) && origem.isNotBlank() && RegrasEfetivo.obraEm(it.aloc, ref) == origem }
        Par(
            largo,
            { m -> Seletor("Obra de origem", centrosAtivos.map { it.id to it.rotulo }, origem, { origem = it; fid = "" }, m) },
            { m ->
                EscolherFuncionario(
                    if (origem.isBlank()) "Escolha a obra de origem primeiro" else "Funcionário (${naOrigem.size} na obra)",
                    naOrigem, fid, { fid = it }, m
                )
            }
        )
        Par(
            largo,
            { m -> Seletor("Obra de destino", centrosAtivos.filter { it.id != origem }.map { it.id to it.rotulo }, destino, { destino = it }, m) },
            { m ->
                Row(m, horizontalArrangement = Arrangement.spacedBy(10.dp)) {
                    Campo("Início (dd/mm/aaaa)", ini, modifier = Modifier.weight(1f)) { ini = it }
                    Campo("Fim (opcional)", fim, modifier = Modifier.weight(1f)) { fim = it }
                }
            }
        )
        Campo("Motivo", motivo) { motivo = it }
        destino.takeIf { it.isNotBlank() }?.let { dst ->
            val c = d.centro(dst)
            Text(
                "Aprovam: origem ${d.codigo(origem.ifBlank { null })} — ${responsavel(d, origem)}; destino ${c?.codigo} — ${responsavel(d, dst)}",
                style = MaterialTheme.typography.bodySmall,
                color = PortalCores.CinzaTexto
            )
        }
        erroForm?.let { Text(it, color = PortalCores.Vermelho) }
        PortalButton(
            onClick = {
                val i = Datas.iso(ini)
                val f = if (fim.isBlank()) "" else Datas.iso(fim)
                erroForm = when {
                    fid.isBlank() -> "Selecione o funcionário."
                    destino.isBlank() -> "Selecione a obra de destino."
                    i == null -> "Data de início inválida."
                    f == null -> "Data final inválida."
                    else -> null
                }
                if (erroForm != null) return@PortalButton
                val (fidF, oriF, dstF, mot) = listOf(fid, origem, destino, motivo)
                executar("Transferência solicitada.") {
                    EfetivoApi.solicitarTransferencia(fidF, oriF, dstF, i!!, f!!, mot)
                }
                fid = ""; destino = ""; fim = ""; motivo = ""
            }
        ) { Text("Solicitar transferência") }
    }

    val abertas = d.transferencias.filter { it.aberta }
    val fechadas = d.transferencias.filterNot { it.aberta }
    CartaoSecao("Pendentes (${abertas.size})") {
        if (abertas.isEmpty()) Text("Nenhuma transferência pendente.", color = PortalCores.CinzaTexto)
        abertas.forEach { CartaoTransferencia(d, it, executar) }
    }
    CartaoSecao("Histórico (${fechadas.size})") {
        if (fechadas.isEmpty()) Text("Sem histórico ainda.", color = PortalCores.CinzaTexto)
        fechadas.take(100).forEach { CartaoTransferencia(d, it, executar) }
    }
}

private fun responsavel(d: EfetivoDados, cc: String): String {
    val c = d.centro(cc) ?: return "—"
    return when {
        c.engenheiro.isBlank() -> "sem engenheiro cadastrado (só o Master aprova)"
        else -> c.engenheiroNome.ifBlank { c.engenheiro }
    }
}

@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun CartaoTransferencia(d: EfetivoDados, t: Transferencia, executar: (String, suspend () -> Result<*>) -> Unit) {
    val agora = currentTimeMillis()
    val nome = d.func(t.fid)?.nome ?: "Funcionário removido"
    Column(
        Modifier.fillMaxWidth().border(1.dp, PortalCores.Borda, RoundedCornerShape(10.dp)).padding(12.dp),
        verticalArrangement = Arrangement.spacedBy(6.dp)
    ) {
        FlowRow(horizontalArrangement = Arrangement.spacedBy(8.dp), verticalArrangement = Arrangement.spacedBy(4.dp)) {
            Text(nome, fontWeight = FontWeight.Bold, color = PortalCores.TextoForte)
            val (rot, cor) = chipTransf(t)
            ChipCor(rot, cor)
            if (t.vencida(agora)) ChipCor("Prazo de 2 dias vencido", PortalCores.Vermelho)
        }
        Text(
            "${d.rotulo(t.origem)}  →  ${d.rotulo(t.destino)} · de ${Datas.br(t.ini)}" +
                (t.fim?.let { " até ${Datas.br(it)}" } ?: " sem data final")
        )
        if (t.motivo.isNotBlank()) Text("Motivo: ${t.motivo}", color = PortalCores.CinzaTexto)
        Text(
            "Solicitada por ${t.solicitanteNome} em ${formatDateTimeBr(t.criada)} · prazo ${formatDateTimeBr(t.prazo)}" +
                (t.avisoDiretoria?.let { " · aviso à diretoria em ${formatDateTimeBr(it)}" } ?: ""),
            style = MaterialTheme.typography.bodySmall,
            color = PortalCores.CinzaTexto
        )
        listOf("origem", "destino").forEach { k ->
            val l = t.lado(k)
            Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                Text("${if (k == "origem") "Origem" else "Destino"} ${d.codigo(l.obra)}:", color = PortalCores.CinzaTexto)
                when (l.dec) {
                    "aprovada" -> {
                        ChipCor("Aprovada", PortalCores.Verde)
                        Text(l.porNome.ifBlank { l.por } + if (l.auto) " (automática, solicitante responsável)" else "", style = MaterialTheme.typography.bodySmall)
                    }
                    "recusada" -> {
                        ChipCor("Recusada", PortalCores.Vermelho)
                        Text(l.porNome.ifBlank { l.por } + if (l.com.isNotBlank()) " — ${l.com}" else "", style = MaterialTheme.typography.bodySmall)
                    }
                    else -> {
                        ChipCor("Aguardando", PortalCores.Laranja)
                        Text(responsavel(d, l.obra), style = MaterialTheme.typography.bodySmall)
                    }
                }
            }
        }
        if (t.aberta) {
            var comentario by remember(t.id) { mutableStateOf("") }
            val ladosMeus = listOf("origem", "destino").filter { t.lado(it).dec == "pendente" && d.podeDecidir(t.lado(it).obra) }
            if (ladosMeus.isNotEmpty()) Campo("Comentário (opcional)", comentario) { comentario = it }
            FlowRow(horizontalArrangement = Arrangement.spacedBy(8.dp), verticalArrangement = Arrangement.spacedBy(6.dp)) {
                ladosMeus.forEach { k ->
                    PortalButton(onClick = {
                        executar("Aprovação registrada.") { EfetivoApi.acaoTransferencia(t.id, "aprovar", k, comentario) }
                    }) { Text("Aprovar ($k)") }
                    PortalOutlinedButton(
                        onClick = { executar("Recusa registrada.") { EfetivoApi.acaoTransferencia(t.id, "recusar", k, comentario) } },
                        colors = ButtonDefaults.outlinedButtonColors(contentColor = PortalCores.Vermelho)
                    ) { Text("Recusar ($k)") }
                }
                if (d.master || t.solicitante.equals(d.usuario, ignoreCase = true)) {
                    PortalOutlinedButton(onClick = {
                        executar("Solicitação cancelada.") { EfetivoApi.acaoTransferencia(t.id, "cancelar") }
                    }) { Text("Cancelar solicitação") }
                }
                if (t.vencida(agora) && t.avisoDiretoria == null) {
                    PortalOutlinedButton(onClick = {
                        executar("Aviso à diretoria registrado.") { EfetivoApi.acaoTransferencia(t.id, "avisar") }
                    }) { Text("Registrar aviso à diretoria") }
                }
            }
        }
    }
}

// ---------------------------------------------------------------- Lançamentos

@Composable
private fun AbaLancamentos(d: EfetivoDados, ref: String, largo: Boolean, executar: (String, suspend () -> Result<*>) -> Unit) {
    var fid by remember { mutableStateOf("") }
    var de by remember(ref) { mutableStateOf(Datas.br(ref)) }
    var ate by remember(ref) { mutableStateOf(Datas.br(ref)) }
    var tipo by remember { mutableStateOf("folga") }
    var mes by remember(ref) { mutableStateOf(ref.take(7)) }
    var erroForm by remember { mutableStateOf<String?>(null) }
    val ativos = d.funcionarios.filter { it.noQuadro(ref) }

    CartaoSecao(
        "Lançar tipo de dia",
        subtitulo = "Todo dia nasce como trabalho. Lance só as exceções (folga, férias, afastamento, falta, descanso, feriado). " +
            "Para desfazer, lance \"Trabalho\". Retroativos são aceitos e ficam em Alterações."
    ) {
        EscolherFuncionario("Funcionário", ativos, fid, { fid = it }, Modifier.fillMaxWidth(), d)
        Par(
            largo,
            { m ->
                Row(m, horizontalArrangement = Arrangement.spacedBy(10.dp)) {
                    Campo("De (dd/mm/aaaa)", de, modifier = Modifier.weight(1f)) { de = it }
                    Campo("Até", ate, modifier = Modifier.weight(1f)) { ate = it }
                }
            },
            { m -> Seletor("Tipo", TiposDia.todos, tipo, { tipo = it }, m) }
        )
        erroForm?.let { Text(it, color = PortalCores.Vermelho) }
        PortalButton(onClick = {
            val a = Datas.iso(de)
            val b = Datas.iso(ate)
            erroForm = when {
                fid.isBlank() -> "Selecione o funcionário."
                a == null || b == null || b < a -> "Período inválido."
                else -> null
            }
            if (erroForm != null) return@PortalButton
            val (f, t) = fid to tipo
            executar("Lançamento registrado.") { EfetivoApi.lancar(f, a!!, b!!, t) }
        }, enabled = d.podeEditar) { Text("Lançar") }
    }

    val f = d.func(fid)
    CartaoSecao("Calendário do funcionário", acoes = {
        if (f != null) SeletorMes(mes) { mes = it }
    }) {
        if (f == null) {
            Text("Selecione um funcionário acima para ver o mês.", color = PortalCores.CinzaTexto)
            return@CartaoSecao
        }
        Text("${f.nome} · matrícula ${f.matricula.ifBlank { "—" }}", fontWeight = FontWeight.SemiBold)
        val (a, b) = Datas.mesRange(mes)
        TabelaPortal(cabecalho = {
            CelulaCabecalho("Data", 1f)
            CelulaCabecalho("Dia", 0.7f)
            CelulaCabecalho("Tipo", 1.4f)
            CelulaCabecalho("Obra", 1.4f)
        }) {
            Datas.dias(a, b).forEach { dia ->
                val noVinculo = f.noQuadro(dia)
                val t = RegrasEfetivo.tipoDia(f, dia)
                Box(Modifier.background(if (Datas.fimDeSemana(dia)) PortalCores.FundoPainel else Color.Transparent)) {
                    LinhaTabela {
                        Celula(Datas.br(dia), 1f)
                        Celula(Datas.DIAS_SEMANA[Datas.dow(dia)], 0.7f)
                        Box(Modifier.weight(1.4f)) {
                            when {
                                !noVinculo -> Text("fora do vínculo", color = PortalCores.CinzaClaro)
                                t == TiposDia.TRABALHO -> Text("Trabalho")
                                else -> ChipCor(TiposDia.rotulo(t), corTipo(t))
                            }
                        }
                        Celula(if (noVinculo) d.codigo(RegrasEfetivo.obraEm(f.aloc, dia)) else "", 1.4f)
                    }
                }
            }
        }
    }
}

// ---------------------------------------------------------------- Folgas

@Composable
private fun AbaFolgas(d: EfetivoDados, ref: String, largo: Boolean) {
    var mes by remember(ref) { mutableStateOf(ref.take(7)) }
    var obra by remember { mutableStateOf("") }
    var calendario by remember { mutableStateOf(false) }

    val linhas = d.funcionarios.filter { it.noQuadro(ref) && (obra.isBlank() || RegrasEfetivo.obraEm(it.aloc, ref) == obra) }
        .map { Triple(it, RegrasEfetivo.folgaStatus(it, ref), RegrasEfetivo.fimDeSemanaTrabalhado(it, mes)) }
    val ordem = mapOf(FolgaStatus.ATRASADA to 0, FolgaStatus.PROXIMA to 1, FolgaStatus.ADIADA to 2, FolgaStatus.EM_DIA to 3, FolgaStatus.SEM_DATA to 4)
    val ordenadas = linhas.sortedWith(compareBy<Triple<FuncEfetivo, FolgaStatus, Int>> { ordem[it.second.status] ?: 9 }.thenByDescending { it.second.dias })

    LinhaKpis(largo) { m ->
        Kpi("Atrasadas", linhas.count { it.second.status == FolgaStatus.ATRASADA }.toString(), Icons.Filled.Warning, m,
            alerta = linhas.any { it.second.status == FolgaStatus.ATRASADA })
        Kpi("Folga próxima", linhas.count { it.second.status == FolgaStatus.PROXIMA }.toString(), Icons.Filled.DateRange, m)
        Kpi("Adiadas p/ fim de ano", linhas.count { it.second.status == FolgaStatus.ADIADA }.toString(), Icons.Filled.DateRange, m)
        Kpi("Em dia", linhas.count { it.second.status == FolgaStatus.EM_DIA }.toString(), Icons.Filled.Person, m, cor = PortalCores.Verde)
    }

    CartaoSecao(
        "Folgas e fins de semana",
        subtitulo = "Dias corridos desde a última folga, férias ou afastamento. Regime 60/6 ou 90/9 por funcionário, referência em ${Datas.br(ref)}.",
        acoes = { SeletorMes(mes) { mes = it } }
    ) {
        val filtrosFolga: @Composable androidx.compose.foundation.layout.ColumnScope.() -> Unit = {
            Par(
                largo,
                { m -> Seletor("Obra", listOf("" to "Todas as obras") + d.centros.map { it.id to it.rotulo }, obra, { obra = it }, m) },
                { m ->
                    Row(m, horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                        OpcaoResposta("Tabela", !calendario, PortalCores.Navy, { calendario = false }, Modifier.weight(1f))
                        OpcaoResposta("Calendário", calendario, PortalCores.Navy, { calendario = true }, Modifier.weight(1f))
                    }
                }
            )
        }
        if (calendario) {
            PainelFixo { Column(verticalArrangement = Arrangement.spacedBy(12.dp), content = filtrosFolga) }
            CalendarioFolgas(d, ref, mes, obra)
        } else if (largo) {
            val ordem = rememberOrdem("NOME")
            val vis = ordem.aplicar(ordenadas) { (f, st, fs) ->
                when (ordem.col) {
                    "OBRA" -> d.codigo(RegrasEfetivo.obraEm(f.aloc, ref))
                    "REGIME" -> f.regime.toString().padStart(4, '0')
                    "FOLGA" -> st.ultima
                    "DIAS" -> st.dias.toString().padStart(5, '0')
                    "LIMITE" -> st.limite
                    "SIT" -> st.status
                    "FDS" -> fs.toString().padStart(4, '0')
                    else -> f.nome
                }
            }
            TabelaPortal(antes = filtrosFolga, fixar = true, cabecalho = {
                CelulaCabecalhoOrdenavel("Funcionário", 2.2f, ordem.marca("NOME")) { ordem.clique("NOME") }
                CelulaCabecalhoOrdenavel("Obra", 0.8f, ordem.marca("OBRA")) { ordem.clique("OBRA") }
                CelulaCabecalhoOrdenavel("Regime", 0.8f, ordem.marca("REGIME")) { ordem.clique("REGIME") }
                CelulaCabecalhoOrdenavel("Última folga", 1f, ordem.marca("FOLGA")) { ordem.clique("FOLGA") }
                CelulaCabecalhoOrdenavel("Dias", 0.6f, ordem.marca("DIAS")) { ordem.clique("DIAS") }
                CelulaCabecalhoOrdenavel("Limite", 1f, ordem.marca("LIMITE")) { ordem.clique("LIMITE") }
                CelulaCabecalhoOrdenavel("Situação", 1.5f, ordem.marca("SIT")) { ordem.clique("SIT") }
                CelulaCabecalhoOrdenavel("Sáb/dom trab. ${Datas.mesRotulo(mes)}", 1.1f, ordem.marca("FDS")) { ordem.clique("FDS") }
            }) {
                vis.forEach { (f, st, fs) ->
                    LinhaTabela {
                        Celula(f.nome, 2.2f, negrito = true)
                        Celula(d.codigo(RegrasEfetivo.obraEm(f.aloc, ref)), 0.8f)
                        Celula("${f.regime} / ${f.regime / 10}", 0.8f)
                        Celula(Datas.br(st.ultima), 1f)
                        Celula(st.dias.toString(), 0.6f)
                        Celula(Datas.br(st.limite), 1f)
                        Box(Modifier.weight(1.5f)) { chipFolga(st.status).let { (r, c) -> ChipCor(r, c) } }
                        Celula(fs.toString(), 1.1f)
                    }
                }
            }
        } else {
            PainelFixo { Column(verticalArrangement = Arrangement.spacedBy(12.dp), content = filtrosFolga) }
            ordenadas.forEach { (f, st, fs) ->
                Column(Modifier.fillMaxWidth().border(1.dp, PortalCores.Borda, RoundedCornerShape(10.dp)).padding(10.dp)) {
                    Row(verticalAlignment = Alignment.CenterVertically) {
                        Text(f.nome, Modifier.weight(1f), fontWeight = FontWeight.SemiBold)
                        chipFolga(st.status).let { (r, c) -> ChipCor(r, c) }
                    }
                    Text(
                        "${d.codigo(RegrasEfetivo.obraEm(f.aloc, ref))} · ${st.dias} dias desde ${Datas.br(st.ultima)} · limite ${Datas.br(st.limite)} · $fs sáb/dom trab.",
                        style = MaterialTheme.typography.bodySmall,
                        color = PortalCores.CinzaTexto
                    )
                }
            }
        }
        if (linhas.isEmpty()) Text("Sem funcionários.", color = PortalCores.CinzaTexto)
    }

    val adiadas = linhas.filter { it.second.status == FolgaStatus.ADIADA || (it.second.adiada && it.second.status != FolgaStatus.ATRASADA) }
    CartaoSecao("Folgas adiadas para o fim de ano") {
        if (adiadas.isEmpty()) {
            Text("Nenhuma folga adiada na data de referência.", color = PortalCores.CinzaTexto)
        } else {
            val jan = adiadas.first().second.janela
            Text("${adiadas.size} funcionário(s) com limite a partir de 15/10, a tirar entre ${Datas.br(jan?.first)} e ${Datas.br(jan?.second)}. Efetivo que sai de cada obra na janela:")
            adiadas.groupBy { RegrasEfetivo.obraEm(it.first.aloc, ref) }.toList().sortedBy { d.codigo(it.first) }.forEach { (o, l) ->
                Text("• ${d.rotulo(o)}: ${l.size}", fontWeight = FontWeight.SemiBold)
            }
        }
    }
}

@Composable
private fun CalendarioFolgas(d: EfetivoDados, ref: String, mes: String, obra: String) {
    val (a, b) = Datas.mesRange(mes)
    val dias = Datas.dias(a, b)
    val pessoas = d.funcionarios.filter { f ->
        RegrasEfetivo.vinculo(f, mes) != null && f.noQuadro(ref) &&
            (obra.isBlank() || dias.any { f.noQuadro(it) && RegrasEfetivo.obraEm(f.aloc, it) == obra })
    }
    if (pessoas.isEmpty()) {
        Text("Nenhum funcionário com vínculo neste mês${if (obra.isNotBlank()) " e nesta obra" else ""}.", color = PortalCores.CinzaTexto)
        return
    }
    val cel = 26.dp
    val fora = IntArray(dias.size)
    Column(Modifier.horizontalScroll(rememberScrollState())) {
        Row {
            Text("Funcionário", Modifier.width(210.dp), fontWeight = FontWeight.SemiBold, style = MaterialTheme.typography.labelMedium)
            dias.forEach { dia ->
                Column(
                    Modifier.width(cel).background(if (dia == ref) PortalCores.Navy.copy(alpha = 0.15f) else if (Datas.fimDeSemana(dia)) PortalCores.FundoPainel else Color.Transparent),
                    horizontalAlignment = Alignment.CenterHorizontally
                ) {
                    Text(dia.takeLast(2).trimStart('0'), style = MaterialTheme.typography.labelSmall, fontWeight = FontWeight.SemiBold)
                    Text(Datas.DIAS_SEMANA[Datas.dow(dia)].take(1), style = MaterialTheme.typography.labelSmall, color = PortalCores.CinzaTexto)
                }
            }
            Text("folgas", Modifier.width(52.dp), textAlign = TextAlign.Center, style = MaterialTheme.typography.labelSmall)
            Text("sáb/dom", Modifier.width(60.dp), textAlign = TextAlign.Center, style = MaterialTheme.typography.labelSmall)
        }
        pessoas.forEach { f ->
            val st = RegrasEfetivo.folgaStatus(f, ref)
            var nFolga = 0
            var nFs = 0
            HorizontalDivider(color = PortalCores.Borda, modifier = Modifier.width(210.dp + cel * dias.size + 112.dp))
            Row(verticalAlignment = Alignment.CenterVertically) {
                Text(
                    "${f.nome}  ${d.codigo(RegrasEfetivo.obraEm(f.aloc, ref))}",
                    Modifier.width(210.dp).padding(end = 6.dp),
                    style = MaterialTheme.typography.bodySmall,
                    maxLines = 1
                )
                dias.forEachIndexed { i, dia ->
                    val ativo = f.noQuadro(dia)
                    val t = RegrasEfetivo.tipoDia(f, dia)
                    val fsw = ativo && Datas.fimDeSemana(dia) && t == TiposDia.TRABALHO
                    if (ativo && t != TiposDia.TRABALHO) fora[i]++
                    if (ativo && t == "folga") nFolga++
                    if (fsw) nFs++
                    val fundo = when {
                        !ativo -> PortalCores.CinzaClaro.copy(alpha = 0.25f)
                        t != TiposDia.TRABALHO -> corTipo(t).copy(alpha = 0.18f)
                        Datas.fimDeSemana(dia) -> PortalCores.FundoPainel
                        else -> Color.Transparent
                    }
                    Box(
                        Modifier.width(cel).height(24.dp).background(fundo)
                            .let { if (dia == st.limite) it.border(2.dp, PortalCores.Laranja) else it },
                        contentAlignment = Alignment.Center
                    ) {
                        val letra = if (ativo && t != TiposDia.TRABALHO) TiposDia.letra[t].orEmpty() else if (fsw) "•" else ""
                        Text(letra, fontSize = 11.sp, fontWeight = FontWeight.Bold, color = if (fsw) PortalCores.Laranja else corTipo(t))
                    }
                }
                Text(nFolga.toString(), Modifier.width(52.dp), textAlign = TextAlign.Center, style = MaterialTheme.typography.bodySmall)
                Text(nFs.toString(), Modifier.width(60.dp), textAlign = TextAlign.Center, style = MaterialTheme.typography.bodySmall)
            }
        }
        HorizontalDivider(color = PortalCores.Borda, modifier = Modifier.width(210.dp + cel * dias.size + 112.dp))
        Row {
            Text("Fora do trabalho no dia", Modifier.width(210.dp), style = MaterialTheme.typography.labelMedium, fontWeight = FontWeight.SemiBold)
            fora.forEach { n ->
                Text(if (n > 0) n.toString() else "", Modifier.width(cel), textAlign = TextAlign.Center, style = MaterialTheme.typography.labelSmall)
            }
        }
    }
    Text(
        "F folga · D descanso semanal · V férias · A afastamento · X falta · H feriado · • sáb/dom trabalhado · " +
            "borda laranja = dia limite da próxima folga",
        style = MaterialTheme.typography.bodySmall,
        color = PortalCores.CinzaTexto
    )
}

// ---------------------------------------------------------------- Custo (liberado só quando o servidor ativar)

@Composable
private fun AbaCusto(d: EfetivoDados, largo: Boolean, ref: String, avisar: (String, Color) -> Unit) {
    val scope = rememberCoroutineScope()
    var custos by remember { mutableStateOf<List<CustoMes>?>(null) }
    var comp by remember(ref) { mutableStateOf(ref.take(7)) }
    var texto by remember { mutableStateOf("") }
    var previa by remember { mutableStateOf<ImportacaoFolha?>(null) }

    fun carregar() {
        scope.launch {
            EfetivoApi.custos().onSuccess { custos = it }.onFailure { avisar(it.message ?: "Falha ao carregar custos.", PortalCores.Vermelho) }
        }
    }
    LaunchedEffect(Unit) { carregar() }
    val lista = custos ?: run {
        Text("Carregando custos...", color = PortalCores.CinzaTexto)
        return
    }
    val real = lista.firstOrNull { it.comp == comp }
    val (linhas, semCusto) = RegrasEfetivo.rateio(d.funcionarios, lista, comp)
    data class Soma(var dias: Int = 0, var real: Long = 0, var prov: Long = 0)
    val porObra = linkedMapOf<String, Soma>()
    linhas.forEach { l ->
        val s = porObra.getOrPut(l.obra) { Soma() }
        s.dias += l.dias
        if (l.provisorio) s.prov += l.cents else s.real += l.cents
    }
    val distribReal = linhas.filterNot { it.provisorio }.sumOf { it.cents }

    CartaoSecao("Custo de mão de obra por obra", acoes = { SeletorMes(comp) { comp = it } }) {
        if (real != null) {
            ChipCor("Folha de ${Datas.mesRotulo(comp)} importada · versão ${real.versao} · ${real.importadoPor}", PortalCores.Verde)
        } else {
            ChipCor("Provisório: usa o último valor conhecido de cada funcionário", PortalCores.Laranja)
        }
        val ordem = rememberOrdem("OBRA")
        val chaves = ordem.aplicar(porObra.keys.toList()) { o ->
            val s = porObra.getValue(o)
            when (ordem.col) {
                "DIAS" -> s.dias.toString().padStart(6, '0')
                "REAL" -> s.real.toString().padStart(14, '0')
                "PROV" -> s.prov.toString().padStart(14, '0')
                "TOTAL" -> (s.real + s.prov).toString().padStart(14, '0')
                else -> d.rotulo(o)
            }
        }
        TabelaPortal(cabecalho = {
            CelulaCabecalhoOrdenavel("Obra", 2.2f, ordem.marca("OBRA")) { ordem.clique("OBRA") }
            CelulaCabecalhoOrdenavel("Dias-func.", 0.8f, ordem.marca("DIAS")) { ordem.clique("DIAS") }
            CelulaCabecalhoOrdenavel("Real", 1f, ordem.marca("REAL")) { ordem.clique("REAL") }
            CelulaCabecalhoOrdenavel("Provisório", 1f, ordem.marca("PROV")) { ordem.clique("PROV") }
            CelulaCabecalhoOrdenavel("Total", 1f, ordem.marca("TOTAL")) { ordem.clique("TOTAL") }
        }) {
            chaves.forEach { o ->
                val s = porObra.getValue(o)
                LinhaTabela {
                    Celula(d.rotulo(o.takeIf { it != RegrasEfetivo.SEM_OBRA }), 2.2f, negrito = true)
                    Celula(s.dias.toString(), 0.8f)
                    Celula(centavos(s.real), 1f)
                    Celula(if (s.prov > 0) centavos(s.prov) else "—", 1f)
                    Celula(centavos(s.real + s.prov), 1f, negrito = true)
                }
            }
            LinhaTabela {
                Celula("Total", 2.2f, negrito = true)
                Celula(porObra.values.sumOf { it.dias }.toString(), 0.8f, negrito = true)
                Celula(centavos(porObra.values.sumOf { it.real }), 1f, negrito = true)
                Celula(centavos(porObra.values.sumOf { it.prov }), 1f, negrito = true)
                Celula(centavos(porObra.values.sumOf { it.real + it.prov }), 1f, negrito = true)
            }
        }
        if (real != null) {
            val fecha = distribReal == real.total
            ChipCor(
                if (fecha) "Fecha com a folha (${centavos(real.total)})" else "Diferença de ${centavos(real.total - distribReal)}",
                if (fecha) PortalCores.Verde else PortalCores.Vermelho
            )
        }
        if (semCusto.isNotEmpty()) {
            Text(
                "${semCusto.size} funcionário(s) com vínculo no mês e sem custo conhecido (fora do rateio): " +
                    semCusto.mapNotNull { d.func(it)?.nome }.joinToString(", "),
                color = PortalCores.Vermelho,
                style = MaterialTheme.typography.bodySmall
            )
        }
        Text(
            "Custo do mês dividido pelos dias de vínculo e distribuído pelos dias em cada obra (maior resto fecha os centavos).",
            style = MaterialTheme.typography.bodySmall,
            color = PortalCores.CinzaTexto
        )
    }

    CartaoSecao("Importar folha", subtitulo = "Cole a planilha com as colunas matricula; competencia; valor (competência 2026-09 ou 09/2026).") {
        Campo("Conteúdo da planilha", texto, linhas = 6) { texto = it; previa = null }
        PortalOutlinedButton(onClick = { previa = RegrasEfetivo.parseImport(texto, d.funcionarios) }, enabled = texto.isNotBlank()) {
            Text("Conferir")
        }
        previa?.let { p ->
            if (p.erro != null) {
                Text(p.erro, color = PortalCores.Vermelho)
            } else {
                Text("Competência ${Datas.mesRotulo(p.comp)}: ${p.ok.size} linha(s) casadas, total ${centavos(p.total)}.", color = PortalCores.Verde)
                if (p.naoCasadas.isNotEmpty()) {
                    Text("${p.naoCasadas.size} linha(s) sem funcionário com essa matrícula: " + p.naoCasadas.joinToString("; ") { "linha ${it.first} · ${it.second}" }, color = PortalCores.Vermelho)
                }
                if (p.invalidas.isNotEmpty()) {
                    Text("${p.invalidas.size} linha(s) inválidas: " + p.invalidas.joinToString("; ") { "linha ${it.first} (${it.second})" }, color = PortalCores.Vermelho)
                }
                if (p.ok.isNotEmpty()) {
                    PortalButton(onClick = {
                        scope.launch {
                            EfetivoApi.importarFolha(p)
                                .onSuccess { v ->
                                    avisar("Folha importada (versão $v).", PortalCores.Verde)
                                    comp = p.comp
                                    previa = null
                                    texto = ""
                                    carregar()
                                }
                                .onFailure { avisar(it.message ?: "Falha ao importar.", PortalCores.Vermelho) }
                        }
                    }) { Text("Confirmar importação") }
                }
            }
        }
    }
}

// ---------------------------------------------------------------- Cadastros

@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun AbaCadastros(d: EfetivoDados, ref: String, largo: Boolean, executar: (String, suspend () -> Result<*>) -> Unit) {
    val ativos = d.funcionarios.filter { it.noQuadro(ref) }
    val semObra = ativos.filter { RegrasEfetivo.obraEm(it.aloc, ref) == null }
    val marcados = remember { mutableStateListOf<String>() }
    var ccAloc by remember { mutableStateOf("") }
    var iniAloc by remember(ref) { mutableStateOf(Datas.br(ref)) }
    var buscaSem by remember { mutableStateOf("") }
    var erroAloc by remember { mutableStateOf<String?>(null) }

    CartaoSecao(
        "Funcionários sem obra (${semObra.size})",
        subtitulo = "Alocação inicial: marque os funcionários, escolha a obra e a data de início. " +
            "Quem já está em uma obra muda por Transferências."
    ) {
        if (semObra.isEmpty()) {
            Text("Todos os funcionários ativos estão alocados na data de referência.", color = PortalCores.Verde)
        } else {
            val q = buscaSem.trim()
            val visiveis = semObra.filter {
                q.isEmpty() || it.nome.contains(q, true) || it.matricula.contains(q) || it.funcao.contains(q, true)
            }
            PainelFixo {
                Column(Modifier.fillMaxWidth(), verticalArrangement = Arrangement.spacedBy(12.dp)) {
                    Par(
                        largo,
                        { m -> Seletor("Obra", d.centros.filter { it.ativo }.map { it.id to it.rotulo }, ccAloc, { ccAloc = it }, m) },
                        { m -> Campo("Início (dd/mm/aaaa)", iniAloc, modifier = m) { iniAloc = it } }
                    )
                    CampoBusca(buscaSem, { buscaSem = it }, "Filtrar por nome, matrícula ou função", Modifier.fillMaxWidth())
                    Row(verticalAlignment = Alignment.CenterVertically) {
                        val todos = visiveis.isNotEmpty() && visiveis.all { it.id in marcados }
                        Checkbox(checked = todos, onCheckedChange = { m ->
                            if (m) visiveis.forEach { if (it.id !in marcados) marcados += it.id } else marcados.removeAll(visiveis.map { it.id })
                        })
                        Text("Marcar todos os ${visiveis.size} da lista", Modifier.weight(1f))
                        Text("${marcados.count { id -> semObra.any { it.id == id } }} marcado(s)", color = PortalCores.CinzaTexto)
                    }
                }
            }
            Column(Modifier.fillMaxWidth().border(1.dp, PortalCores.Borda, RoundedCornerShape(10.dp))) {
                visiveis.take(300).forEach { f ->
                    Row(
                        Modifier.fillMaxWidth().clickable { if (f.id in marcados) marcados.remove(f.id) else marcados += f.id }
                            .padding(horizontal = 8.dp, vertical = 2.dp),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        Checkbox(checked = f.id in marcados, onCheckedChange = { if (it) marcados += f.id else marcados.remove(f.id) })
                        Text(f.nome, Modifier.weight(2f), fontWeight = FontWeight.SemiBold)
                        if (largo) Text(f.funcao, Modifier.weight(2f), color = PortalCores.CinzaTexto, style = MaterialTheme.typography.bodySmall)
                        if (f.vinculo.isNotBlank()) ChipCor(f.vinculo.uppercase(), corVinculo(f.vinculo))
                    }
                }
            }
            erroAloc?.let { Text(it, color = PortalCores.Vermelho) }
            PortalButton(onClick = {
                val ini = Datas.iso(iniAloc)
                val ids = marcados.filter { id -> semObra.any { it.id == id } }
                erroAloc = when {
                    ids.isEmpty() -> "Marque ao menos um funcionário."
                    ccAloc.isBlank() -> "Escolha a obra."
                    ini == null -> "Data de início inválida."
                    else -> null
                }
                if (erroAloc != null) return@PortalButton
                val cc = ccAloc
                executar("Alocação registrada.") {
                    EfetivoApi.alocar(ids, cc, ini!!).onSuccess { (_, recusados) ->
                        if (recusados.isNotEmpty()) erroAloc = "Não alocados: " + recusados.joinToString("; ")
                    }
                }
                marcados.clear()
            }, enabled = d.podeEditar) { Text("Alocar marcados") }
        }
    }

    var busca by remember { mutableStateOf("") }
    var situacaoFiltro by remember { mutableStateOf("ATIVOS") }
    var vinculoFiltro by remember { mutableStateOf("") }
    var funcaoFiltro by remember { mutableStateOf("") }
    var obraFiltro by remember { mutableStateOf("") }
    var editando by remember { mutableStateOf<String?>(null) }
    val noQuadro = d.funcionarios.count { it.noQuadro(ref) }
    CartaoSecao(
        "Funcionários ($noQuadro ativos)",
        subtitulo = "Mesma base de Colaboradores, na data ${Datas.br(ref)}. Ativo: situação ATIVO, já admitido e sem desligamento. Afastado e desligado ficam nos filtros."
    ) {
        val q = busca.trim()
        val funcoes = remember(d.funcionarios) {
            d.funcionarios.map { it.funcao }.filter { it.isNotBlank() }.distinct().sorted()
        }
        val lista = d.funcionarios.filter { f ->
            when (situacaoFiltro) {
                "AFASTADOS" -> f.afastadoCadastro() && !f.desativadoCadastro()
                "DESLIGADOS" -> f.desativadoCadastro() || (f.desligamento != null && f.desligamento < ref)
                "TODOS" -> true
                else -> f.noQuadro(ref)
            }
        }.filter { f ->
            vinculoFiltro.isBlank() || f.vinculo.equals(vinculoFiltro, true)
        }.filter { f ->
            funcaoFiltro.isBlank() || f.funcao == funcaoFiltro
        }.filter { f ->
            when (obraFiltro) {
                "" -> true
                "__SEM__" -> RegrasEfetivo.obraCadastrada(f.aloc, ref) == null
                else -> RegrasEfetivo.obraCadastrada(f.aloc, ref) == obraFiltro
            }
        }.filter { f ->
            q.isEmpty() || f.nome.contains(q, true) || f.matricula.contains(q) || f.funcao.contains(q, true)
        }
        val filtrosCad: @Composable androidx.compose.foundation.layout.ColumnScope.() -> Unit = {
            Text("${lista.size} de ${d.funcionarios.size} no cadastro · $noQuadro ativos nesta data", color = PortalCores.CinzaTexto, style = MaterialTheme.typography.bodySmall)
            FlowRow(horizontalArrangement = Arrangement.spacedBy(8.dp), verticalArrangement = Arrangement.spacedBy(8.dp)) {
                listOf("" to "Todos", "CLT" to "CLT", "PJ" to "PJ").forEach { (v, rot) ->
                    TextButton(onClick = { vinculoFiltro = v }) {
                        Text(rot, fontWeight = if (vinculoFiltro == v) FontWeight.Bold else FontWeight.Normal)
                    }
                }
            }
            val w = if (largo) Modifier.width(220.dp) else Modifier.fillMaxWidth()
            FlowRow(horizontalArrangement = Arrangement.spacedBy(10.dp), verticalArrangement = Arrangement.spacedBy(8.dp)) {
                CampoBusca(busca, { busca = it }, "Buscar por nome, matrícula ou função", if (largo) Modifier.width(280.dp) else Modifier.fillMaxWidth())
                Seletor(
                    "Situação",
                    listOf("ATIVOS" to "Ativos", "AFASTADOS" to "Afastados", "DESLIGADOS" to "Desligados", "TODOS" to "Todos"),
                    situacaoFiltro,
                    { situacaoFiltro = it },
                    w
                )
                Seletor("Função", listOf("" to "Todas") + funcoes.map { it to it }, funcaoFiltro, { funcaoFiltro = it }, w)
                Seletor(
                    "Obra",
                    listOf("" to "Todas", "__SEM__" to "Sem obra") + d.centros.filter { it.ativo }.map { it.id to it.rotulo },
                    obraFiltro,
                    { obraFiltro = it },
                    if (largo) Modifier.width(320.dp) else Modifier.fillMaxWidth()
                )
            }
        }
        val ordem = rememberOrdem("NOME")
        val linhas = ordem.aplicar(lista) { f ->
            when (ordem.col) {
                "MTR" -> f.matricula
                "VINC" -> f.vinculo
                "OBRA" -> d.codigo(RegrasEfetivo.obraCadastrada(f.aloc, ref))
                "ADM" -> f.admissao
                "REG" -> f.regime.toString().padStart(4, '0')
                "DESL" -> f.desligamento.orEmpty()
                else -> f.nome
            }
        }
        if (largo) {
            TabelaPortal(antes = filtrosCad, fixar = true, cabecalho = {
                CelulaCabecalhoOrdenavel("MTR", 0.7f, ordem.marca("MTR")) { ordem.clique("MTR") }
                CelulaCabecalhoOrdenavel("Nome / função", 2.6f, ordem.marca("NOME")) { ordem.clique("NOME") }
                CelulaCabecalhoOrdenavel("Vínculo", 0.7f, ordem.marca("VINC")) { ordem.clique("VINC") }
                CelulaCabecalhoOrdenavel("Obra", 0.9f, ordem.marca("OBRA")) { ordem.clique("OBRA") }
                CelulaCabecalhoOrdenavel("Admissão", 1f, ordem.marca("ADM")) { ordem.clique("ADM") }
                CelulaCabecalhoOrdenavel("Regime", 0.8f, ordem.marca("REG")) { ordem.clique("REG") }
                CelulaCabecalhoOrdenavel("Desligamento", 1f, ordem.marca("DESL")) { ordem.clique("DESL") }
            }) {
                linhas.take(300).forEach { f ->
                    LinhaTabela(onClick = { editando = f.id }) {
                        Celula(f.matricula.ifBlank { "—" }, 0.7f)
                        Column(Modifier.weight(2.6f).padding(end = 10.dp)) {
                            Text(f.nome, fontWeight = FontWeight.SemiBold)
                            Text(f.funcao, style = MaterialTheme.typography.bodySmall, color = PortalCores.CinzaTexto)
                        }
                        Box(Modifier.weight(0.7f)) { if (f.vinculo.isNotBlank()) ChipCor(f.vinculo.uppercase(), corVinculo(f.vinculo)) }
                        Celula(d.codigo(RegrasEfetivo.obraCadastrada(f.aloc, ref)), 0.9f)
                        Celula(Datas.br(f.admissao).ifBlank { "—" }, 1f)
                        Celula("${f.regime} / ${f.regime / 10}", 0.8f)
                        Celula(f.desligamento?.let { Datas.br(it) } ?: "—", 1f, cor = if (f.desligamento != null) PortalCores.Vermelho else PortalCores.Texto)
                    }
                }
            }
        } else {
            PainelFixo { Column(verticalArrangement = Arrangement.spacedBy(12.dp), content = filtrosCad) }
            lista.take(300).forEach { f ->
                Column(
                    Modifier.fillMaxWidth().border(1.dp, PortalCores.Borda, RoundedCornerShape(10.dp)).clickable { editando = f.id }.padding(10.dp)
                ) {
                    Text(f.nome, fontWeight = FontWeight.SemiBold)
                    Text(
                        "${f.funcao} · ${d.codigo(RegrasEfetivo.obraCadastrada(f.aloc, ref))} · regime ${f.regime}",
                        style = MaterialTheme.typography.bodySmall,
                        color = PortalCores.CinzaTexto
                    )
                }
            }
        }
    }

    CartaoSecao(
        "Obras / centros de custo",
        subtitulo = "Mesma lista do Controle de Ativos. O engenheiro responsável aprova as transferências da obra; para alterar, use Controle de Ativos → Obras / Centros de custo."
    ) {
        val ordem = rememberOrdem("COD")
        val centros = ordem.aplicar(d.centros.filter { it.ativo }) { c ->
            when (ordem.col) {
                "OBRA" -> c.nome
                "ENG" -> c.engenheiroNome.ifBlank { c.engenheiro }
                "QTD" -> ativos.count { RegrasEfetivo.obraEm(it.aloc, ref) == c.id }.toString().padStart(5, '0')
                else -> c.codigo
            }
        }
        TabelaPortal(fixar = true, cabecalho = {
            CelulaCabecalhoOrdenavel("Código", 0.7f, ordem.marca("COD")) { ordem.clique("COD") }
            CelulaCabecalhoOrdenavel("Obra", 2.6f, ordem.marca("OBRA")) { ordem.clique("OBRA") }
            CelulaCabecalhoOrdenavel("Engenheiro responsável", 1.6f, ordem.marca("ENG")) { ordem.clique("ENG") }
            CelulaCabecalhoOrdenavel("Alocados", 0.8f, ordem.marca("QTD")) { ordem.clique("QTD") }
        }) {
            centros.forEach { c ->
                LinhaTabela {
                    Celula(c.codigo, 0.7f, negrito = true)
                    Celula(c.nome, 2.6f)
                    Celula(
                        c.engenheiroNome.ifBlank { c.engenheiro }.ifBlank { "sem engenheiro" },
                        1.6f,
                        cor = if (c.engenheiro.isBlank()) PortalCores.Laranja else PortalCores.Texto
                    )
                    Celula(ativos.count { RegrasEfetivo.obraEm(it.aloc, ref) == c.id }.toString(), 0.8f)
                }
            }
        }
    }

    editando?.let { id ->
        d.func(id)?.let { f -> ModalFuncionario(d, f, { editando = null }, executar) }
    }
}

@Composable
private fun ModalFuncionario(
    d: EfetivoDados,
    f: FuncEfetivo,
    onFechar: () -> Unit,
    executar: (String, suspend () -> Result<*>) -> Unit
) {
    var regime by remember(f.id) { mutableStateOf(f.regime) }
    var deslig by remember(f.id) { mutableStateOf(Datas.br(f.desligamento)) }
    var erroM by remember { mutableStateOf<String?>(null) }
    PortalModal(onFechar = onFechar, larguraMax = 640.dp) {
        Column(Modifier.padding(20.dp), verticalArrangement = Arrangement.spacedBy(12.dp)) {
            Text(f.nome, color = PortalCores.Navy, fontWeight = FontWeight.Bold, style = MaterialTheme.typography.titleLarge)
            Text(
                "Matrícula ${f.matricula.ifBlank { "—" }} · ${f.funcao.ifBlank { "sem função" }} · admissão ${Datas.br(f.admissao).ifBlank { "não informada" }}",
                color = PortalCores.CinzaTexto
            )
            TituloSecao("Regime de folga")
            Row(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                OpcaoResposta("60 dias → 6 de folga", regime == 60, PortalCores.Navy, { regime = 60 }, Modifier.weight(1f))
                OpcaoResposta("90 dias → 9 de folga", regime == 90, PortalCores.Navy, { regime = 90 }, Modifier.weight(1f))
            }
            TituloSecao("Desligamento")
            Campo("Data de desligamento (vazio = ativo)", deslig) { deslig = it }
            TituloSecao("Alocações")
            if (f.aloc.isEmpty()) Text("Sem alocação.", color = PortalCores.CinzaTexto)
            f.aloc.forEach { p ->
                Row(verticalAlignment = Alignment.CenterVertically) {
                    Text(
                        "${d.rotulo(p.cc)} · ${Datas.br(p.ini)} ${p.fim?.let { "a ${Datas.br(it)}" } ?: "em diante"}",
                        Modifier.weight(1f)
                    )
                    if (d.podeExcluir) {
                        TextButton(
                            onClick = { executar("Período removido.") { EfetivoApi.removerAlocacao(p.id) } },
                            colors = ButtonDefaults.textButtonColors(contentColor = PortalCores.Vermelho)
                        ) { Text("Remover") }
                    }
                }
            }
            erroM?.let { Text(it, color = PortalCores.Vermelho) }
            Row(horizontalArrangement = Arrangement.spacedBy(10.dp)) {
                Spacer(Modifier.weight(1f))
                PortalOutlinedButton(onClick = onFechar) { Text("Fechar") }
                PortalButton(onClick = {
                    val iso = if (deslig.isBlank()) "" else Datas.iso(deslig)
                    if (iso == null) {
                        erroM = "Data de desligamento inválida."
                        return@PortalButton
                    }
                    val r = regime
                    executar("Funcionário atualizado.") { EfetivoApi.atualizarFuncionario(f.id, r, iso) }
                    onFechar()
                }, enabled = d.podeEditar) { Text("Salvar") }
            }
        }
    }
}

// ---------------------------------------------------------------- Alterações

@Composable
private fun AbaAlteracoes(d: EfetivoDados) {
    val scope = rememberCoroutineScope()
    var logs by remember { mutableStateOf<List<EfetivoLog>?>(null) }
    var erroL by remember { mutableStateOf<String?>(null) }
    var usuario by remember { mutableStateOf("") }
    var soRetro by remember { mutableStateOf(false) }
    LaunchedEffect(d) {
        scope.launch {
            EfetivoApi.log().onSuccess { logs = it; erroL = null }.onFailure { erroL = it.message }
        }
    }
    CartaoSecao("Histórico de alterações", subtitulo = "Toda alteração do Controle de Efetivo, com a quantidade de dias de retroatividade.") {
        erroL?.let { Text(it, color = PortalCores.Vermelho) }
        val lista = logs ?: run {
            Text("Carregando...", color = PortalCores.CinzaTexto)
            return@CartaoSecao
        }
        val usuarios = lista.map { it.usuario }.distinct().sorted()
        Row(horizontalArrangement = Arrangement.spacedBy(10.dp), verticalAlignment = Alignment.CenterVertically) {
            Seletor(
                "Usuário",
                listOf("" to "Todos") + usuarios.map { u -> u to (lista.first { it.usuario == u }.nome.ifBlank { u }) },
                usuario,
                { usuario = it },
                Modifier.weight(1f)
            )
            OpcaoResposta("Só retroativos", soRetro, PortalCores.Laranja, { soRetro = !soRetro }, Modifier.weight(1f))
        }
        val filtrados = lista.filter { (usuario.isBlank() || it.usuario == usuario) && (!soRetro || it.retro > 0) }
        Text("${filtrados.size} registro(s)", color = PortalCores.CinzaTexto, style = MaterialTheme.typography.bodySmall)
        filtrados.forEach { l ->
            Column(Modifier.fillMaxWidth().padding(vertical = 4.dp)) {
                Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                    Text(formatDateTimeBr(l.createdAt), style = MaterialTheme.typography.bodySmall, color = PortalCores.CinzaTexto)
                    Text(l.acao, fontWeight = FontWeight.SemiBold, color = PortalCores.Navy)
                    Text("· ${l.nome.ifBlank { l.usuario }}", style = MaterialTheme.typography.bodySmall)
                    if (l.retro > 0) ChipCor("retroativo, ${l.retro} dia(s)", PortalCores.Laranja)
                }
                Text(l.txt)
            }
            HorizontalDivider(color = PortalCores.Borda)
        }
    }
}

// ---------------------------------------------------------------- componentes

@Composable
private fun SeletorMes(comp: String, onChange: (String) -> Unit) {
    Row(verticalAlignment = Alignment.CenterVertically) {
        IconButton(onClick = { onChange(Datas.compAnterior(comp)) }) {
            Icon(Icons.Filled.ArrowBack, contentDescription = "Mês anterior", tint = PortalCores.Navy)
        }
        Text(Datas.mesRotulo(comp), fontWeight = FontWeight.Bold, color = PortalCores.Navy)
        IconButton(onClick = { onChange(Datas.compSeguinte(comp)) }) {
            Icon(Icons.Filled.ArrowForward, contentDescription = "Mês seguinte", tint = PortalCores.Navy)
        }
    }
}

/** Busca por nome/matrícula/função com lista de sugestões; mostra o escolhido com "Trocar". */
@Composable
private fun EscolherFuncionario(
    rotulo: String,
    lista: List<FuncEfetivo>,
    selecionado: String,
    onSelect: (String) -> Unit,
    modifier: Modifier,
    dados: EfetivoDados? = null
) {
    var busca by remember { mutableStateOf("") }
    val escolhido = lista.firstOrNull { it.id == selecionado }
    Column(modifier, verticalArrangement = Arrangement.spacedBy(6.dp)) {
        Text(rotulo, style = MaterialTheme.typography.labelMedium, color = PortalCores.CinzaTexto)
        if (escolhido != null) {
            Row(
                Modifier.fillMaxWidth().border(1.dp, PortalCores.Navy, RoundedCornerShape(10.dp)).padding(horizontal = 12.dp, vertical = 6.dp),
                verticalAlignment = Alignment.CenterVertically
            ) {
                Icon(Icons.Filled.Person, contentDescription = null, tint = PortalCores.Navy, modifier = Modifier.size(18.dp))
                Spacer(Modifier.width(8.dp))
                Column(Modifier.weight(1f)) {
                    Text(escolhido.nome, fontWeight = FontWeight.SemiBold)
                    Text(
                        listOfNotNull(
                            escolhido.matricula.takeIf { it.isNotBlank() }?.let { "MTR $it" },
                            escolhido.funcao.takeIf { it.isNotBlank() },
                            escolhido.vinculo.takeIf { it.isNotBlank() }?.uppercase(),
                            dados?.let { d -> d.codigo(escolhido.aloc.lastOrNull()?.cc) }
                        ).joinToString(" · "),
                        style = MaterialTheme.typography.bodySmall,
                        color = PortalCores.CinzaTexto
                    )
                }
                TextButton(onClick = { onSelect(""); busca = "" }) { Text("Trocar") }
            }
        } else {
            CampoBusca(busca, { busca = it }, "Digite o nome, matrícula ou função", Modifier.fillMaxWidth())
            val q = busca.trim()
            if (q.length >= 2) {
                val achados = lista.filter { it.nome.contains(q, true) || it.matricula.contains(q) || it.funcao.contains(q, true) }.take(8)
                if (achados.isEmpty()) Text("Nenhum funcionário encontrado.", color = PortalCores.CinzaTexto, style = MaterialTheme.typography.bodySmall)
                Column(Modifier.fillMaxWidth().border(1.dp, PortalCores.Borda, RoundedCornerShape(10.dp))) {
                    achados.forEach { f ->
                        Row(
                            Modifier.fillMaxWidth().clickable { onSelect(f.id); busca = "" }.padding(horizontal = 12.dp, vertical = 8.dp),
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            Column(Modifier.weight(1f)) {
                                Text(f.nome, fontWeight = FontWeight.SemiBold)
                                Text(
                                    listOfNotNull(f.matricula.takeIf { it.isNotBlank() }?.let { "MTR $it" }, f.funcao.takeIf { it.isNotBlank() }).joinToString(" · "),
                                    style = MaterialTheme.typography.bodySmall,
                                    color = PortalCores.CinzaTexto
                                )
                            }
                            if (f.vinculo.isNotBlank()) ChipCor(f.vinculo.uppercase(), corVinculo(f.vinculo))
                        }
                    }
                }
            } else if (lista.isEmpty()) {
                Text("Nenhum funcionário disponível.", color = PortalCores.CinzaTexto, style = MaterialTheme.typography.bodySmall)
            }
        }
    }
}
